module.exports = __webpack_public_path__ + "static/media/referral-badge-bg-1680x1050px.04949389.jpg";